module.exports = __webpack_public_path__ + "img/attach.0dc86735.svg";